/** Draws the server-owned product summary. Only responsive layout and text clipping belong here. */
import type { ShopifyResultProductDisplay } from '@testfeed/shopify-contracts'
import { SectionFrame } from '../study-builder/SectionFrame'
import './ServerResultProduct.css'
export function ServerResultProduct({ product }: { product: ShopifyResultProductDisplay }) {
  const data = product.data
  const image = data.image ? (
    <img className="tf-result-product-image" src={data.image.src} alt={data.image.alt} />
  ) : null
  const badge = data.badge ? <s-badge tone={data.badge.tone}>{data.badge.text}</s-badge> : null
  const detail = data.detail ? <p className="tf-result-product-description">{data.detail}</p> : null
  return (
    <SectionFrame {...product.header}>
      <div className="tf-result-product-summary">
        {image}
        <div className="tf-result-product-copy">
          <s-stack direction="inline" gap="small-200" alignItems="center">
            <s-text type="strong">{data.title}</s-text>
            {badge}
          </s-stack>
          {detail}
        </div>
      </div>
    </SectionFrame>
  )
}
